var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cardContent flex" },
    [
      _vm._m(0),
      _vm._l(_vm.list, function (item, i) {
        return _c(
          "div",
          {
            key: i,
            class: "pp-item pp-item" + (i + 1),
            on: {
              click: function ($event) {
                return _vm.onppClick(item)
              },
            },
          },
          [
            _c("img", { attrs: { src: item.linePic } }),
            _c("div", { staticClass: "name-box" }, [
              _c("p", { staticClass: "name" }, [_vm._v(_vm._s(item.title))]),
              item.num > 0
                ? _c("p", { staticClass: "value" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(item.num)),
                    ]),
                    _vm._v("(" + _vm._s(item.unit) + ") "),
                  ])
                : _c("p", { staticClass: "value" }, [_vm._v(" -（个） ")]),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href: "http://mmsgdsj.maoming.gov.cn/lzlogo",
          target: "_blank",
        },
      },
      [
        _c("img", {
          staticClass: "center-logo",
          attrs: { src: require("images/index/cyzl/mm_logo.png") },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }